// extracted by mini-css-extract-plugin
export default {"dashboard":"style_dashboard__4GH8D"};